import { validateCanvasFontFamily } from './font-utils';

// 用于缓存已经探测过的字体
const fontFamilySupportCache = {};

/**
 * 绘制文字 canvas 相关
 */
const canvasWidth = 30;
const canvasHeight = 40;
let context: CanvasRenderingContext2D | null = null;
/**
 * 获取绘制文字使用的 context，整个应用生命周期复用一个
 * @returns
 */
function getRenderContext() {
    if (!context) {
        const canvas = document.createElement('canvas');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        context = canvas.getContext('2d');
    }
    return context;
}

/**
 * 检查当前设备是否支持传入的字体
 * 原理是分别使用指定字体和默认字体渲染一个字符，比对两次绘制的结果
 * 如果两次结果一致，说明两次渲染都使用了默认字体，说明不支持当前字体
 * @param fontFamilyParam
 * @param letter
 * @returns
 */
export function isSupportFontFamily(fontFamilyParam: string, letter = 'a'): boolean {
    // 合法化字体
    const fontFamily = validateCanvasFontFamily(fontFamilyParam);

    // 如果有缓存，直接返回
    if (fontFamily in fontFamilySupportCache) {
        return fontFamilySupportCache[fontFamily];
    }
    if (typeof fontFamily !== 'string') {
        return false;
    }
    // 默认字体，sans-serif 是非衬线字体族，所有设备上应该都能找到对应的字体
    const defaultFontFamily = 'sans-serif';
    const defaultFontSize = 20;

    if (fontFamily === `'${defaultFontFamily}'` || fontFamily === `"${defaultFontFamily}"`) {
        // 如果是默认字体，直接返回 true
        return true;
    }

    // 获取绘制使用的 context
    const renderContext = getRenderContext();
    if (!renderContext) {
        return false;
    }

    // 全局一致的绘制设定
    renderContext.textAlign = 'center';
    renderContext.fillStyle = 'black';
    renderContext.textBaseline = 'middle';
    const getFontData = function (fontFamily: string) {
        // 清除
        renderContext.clearRect(0, 0, canvasWidth, canvasHeight);
        // 设置字体
        renderContext.font = `${defaultFontSize}px ${fontFamily}, ${defaultFontFamily}`;
        renderContext.fillText(letter, 5, 25);
        const { data } = renderContext.getImageData(0, 0, canvasWidth, canvasHeight);
        return [].slice.call(data).filter((value: number) => value !== 0);
    };
    const isSupport = getFontData(defaultFontFamily).join('') !== getFontData(fontFamily).join('');
    // 缓存起来
    fontFamilySupportCache[fontFamily] = isSupport;
    return isSupport;
}
